import type { Prototype } from "../prototype-types";

export const timHooverPrototypes: Prototype[] = [
  {
    id: "design-faire-com-v2",
    name: "design.faire.com v2",
    path: "/th/design-faire-com-v2",
    description:
      "A redesign exploration of design.faire.com with dark mode support, featuring a home page and post reading experience.",
    owner: "Tim Hoover",
    createdAt: "2026-03-27",
    lastUpdated: "2026-03-27",
    surfaceArea: "Creative",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/d7168d46622f13ecffd7f7feefdd2682135c71f4fd534fa9f96c9d98301ed08e.png",
    creationTool: "cursor",
  },
  {
    id: "brand-catalog-view",
    name: "Dense Catalog View",
    path: "/th/brand/audreys-home-gift",
    description:
      'Brand page for Audrey\'s Home & Gift with "View Catalog" button that opens a fullscreen modal with 24px inset. Features three view modes: Dense Grid, Table/Line Sheet, and Catalog Spread. Inspired by print catalog layouts with brand-curated collections.',
    owner: "Tim",
    createdAt: "2025-12-12",
    lastUpdated: "2025-12-12",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6604f4ce77de2b6963271531ebf84877615617a7ce1d4a935b4e51b0aa0781f6.png",
    creationTool: "cursor",
  },
  {
    id: "brand-analytics-colors",
    name: "Brand Analytics Color Explorer",
    path: "/th/brand-analytics-colors",
    description:
      "Interactive tool for exploring data visualization color palettes. Create and compare multiple color versions across bar, line, pie, and area charts.",
    owner: "Tim",
    createdAt: "2025-12-12",
    lastUpdated: "2025-12-12",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/37271270717fd687fc95848fab560fe0c4df4ddaf07c0ea2c954548394227f16.png",
    creationTool: "cursor",
  },
  {
    id: "th-doppelganger",
    name: "Doppelganger",
    path: "/th/doppelganger",
    description:
      "iOS mobile prototype showing a Doppelganger feature that matches retailers with similar buying patterns and lets them auto-follow each other&#39;s purchases",
    owner: "Tim Hoover",
    createdAt: "2026-05-05",
    lastUpdated: "2026-05-05",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "mobile",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/762a531c193b221458888e913d29b704d529926cbb562e23d75fefedf6fcaae2.png",
    creationTool: "claude-code",
  },
  {
    id: "th-brand-page-faqs",
    name: "Brand Page FAQs",
    path: "/th/brand-page-faqs",
    description: "Adding brand owned FAQs to the brand page",
    owner: "Tim Hoover",
    createdAt: "2026-05-20",
    lastUpdated: "2026-05-20",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/460aad7fa208c13dd439c39d71034bf4b40a91bb8be3a6d65fb2b7c2d48b27a2.png",
    creationTool: "claude-code",
  },
  {
    id: "th-live-roadmap-demo",
    name: "Live Roadmap Demo",
    path: "/th/live-roadmap-demo",
    description: "Strategy pyramid demo: Mission → North Star → Value Props → 13 bets → Linear project roll-ups",
    owner: "Tim Hoover",
    createdAt: "2026-06-09",
    lastUpdated: "2026-06-09",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/04df908c8e1ae469c8036a1995aaeadd4d9ce16f916e8f714261c111acad3d0d.png",
    creationTool: "claude-code",
  }
];
